import React from "react"
import Header from "../components/header"

const SecondPage = () => (
<>
<Header headerText="Contact" />
    <h1>Hi from the second page</h1>
    <p>Welcome to page 2</p>
</>
)

export default SecondPage
